import { normalizeNewsletterTextAlignment } from "./newsletterText";
import type { NewsletterDefaultDesignSnapshot, NewsletterDefaultDesignSection } from "../../types/src";

/** Legacy snapshots included native values and the source campaign's section count. */
export function normalizeDefaultDesign(value: NewsletterDefaultDesignSnapshot | null | undefined): NewsletterDefaultDesignSnapshot | null {
  if (!value || ![1, 2].includes(value.schema_version) || !Array.isArray(value.sections) ||
      !value.theme || !["modern", "classic", "festive", "editorial", "minimal", "bulletin"].includes(value.theme.style)) return null;
  const isLayout = (layout: unknown) => ["left", "right", "stacked"].includes(String(layout));
  value = {
    ...value,
    text_align: normalizeNewsletterTextAlignment(value.text_align),
    template_id: ["digest", "story", "events"].includes(value.template_id) ? value.template_id : "events",
    theme: {
      style: value.theme.style,
      primary_color: typeof value.theme.primary_color === "string" ? value.theme.primary_color : "",
      accent_color: typeof value.theme.accent_color === "string" ? value.theme.accent_color : "",
    },
    intro_image_layout: isLayout(value.intro_image_layout) ? value.intro_image_layout : undefined,
    sections: value.sections.map((section) => ({
      ...section,
      text_align: normalizeNewsletterTextAlignment(section?.text_align),
      media_layout: isLayout(section?.media_layout) ? section.media_layout : undefined,
    })),
  };
  if (value.schema_version === 2) return value;
  const layout = ["festive", "bulletin"].includes(value.theme.style) ? "stacked" : "left";
  const inherited = (position: unknown) => position === layout || (value.theme.style === "festive" && position === "left");
  const sections: NewsletterDefaultDesignSection[] = value.sections.map((section) => ({
    ...(section.text_align ? { text_align: section.text_align } : {}),
    ...(!inherited(section.media_layout) && section.media_layout ? {media_layout: section.media_layout} : {}),
    ...(section.media_width_ratio != null ? {media_width_ratio: section.media_width_ratio} : {}),
    ...(section.media_height != null && section.media_height !== 300 ? {media_height: section.media_height} : {}),
  }));
  while (sections.length && Object.keys(sections[sections.length - 1]).length === 0) sections.pop();
  return {
    ...value, schema_version: 2, sections,
    intro_image_layout: inherited(value.intro_image_layout) ? undefined : value.intro_image_layout,
    intro_image_width_ratio: value.intro_image_width_ratio ?? undefined,
    intro_image_height: value.intro_image_height === 300 ? undefined : value.intro_image_height,
  };
}
